import easyinvoice from './src/lib/easyinvoice';
export default easyinvoice;
